<template>
  <div style="margin-top: 5px" id="target" v-if="isValidUser">
    <div class="form-row">
      <h3>Refunds</h3>
    </div>
    <div class="form-row">
      <div style="width: 30%" class="form-row-input">
        <ejs-button type="button" cssClass="e-danger" v-on:click.native="onNewRefundClick">
          <font-awesome-icon :icon="['fas', 'plus-square']" style="display: inline" />
          NEW
        </ejs-button>
      </div>
    </div>
    <ejs-grid
      :dataSource="accountingTransactionRefunds"
      ref="refAccountingTransactionRefundsGrid"
      :created="created"
      :allowSorting="true"
      :allowPaging="true"
      :pageSettings="pageSettings"
      :toolbar="toolbarOptions"
      :toolbarClick="toolbarClick"
      :commandClick="cmdRefundInvoiceClick"
      :rowDataBound="rowRefundDataBound"
      :allowTextWrap="true"
      :textWrapSettings="wrapSettings"
      :excelQueryCellInfo="excelQueryCellInfo"
      :allowExcelExport="true"
      :sortSettings="sortOptions"
    >
      <e-columns>
         <e-column headerText="Edit" :commands="commands3" textAlign="center" width="85" />
        <e-column field="invoiceNumber" headerText="Invoice Number" textAlign="Left" width="140" />
        <e-column
          field="invoiceDate"
          headerText="Invoice Date"
          textAlign="center"
          width="140"
          type="date"
          :format="gridDateFormat"
        />
        <e-column
          field="totalAmount"
          headerText="Original Invoice Amount"
          textAlign="center"
          width="140"
          format="C2"
        />
        <e-column
          field="totalLevy"
          headerText="Original Levy Amount"
          textAlign="center"
          width="140"
          format="C2"
        />
        <e-column
          field="invoiceAmount"
          headerText="Original Total Invoice"
          textAlign="center"
          width="140"
          format="C2"
        />
        <e-column
          field="refundAppFee"
          headerText="Refund Application Amount"
          textAlign="Left"
          width="250"
          format="C2"
        />
        <e-column
          field="refundTankFee"
          headerText="Refund Tank Amount"
          textAlign="Left"
          width="120"
          format="C2"
        />
        <e-column
          field="refundLevy"
          headerText="Refund Levy Amount"
          textAlign="Left"
          width="120"
          format="C2"
        />
        <e-column
          field="refundAmount"
          headerText="Refund Amount"
          textAlign="Left"
          width="120"
          format="C2"
        />
        <e-column
          field="cancelledRefundMetDate"
          headerText="Refund Date"
          textAlign="center"
          width="140"
          type="date"
          :format="gridDateFormat"
        />
        <e-column
          field="refundTransactionNumber"
          headerText="Refund Transaction #"
          textAlign="Left"
          width="200"
          clipMode="EllipsisWithTooltip"
        />
        <e-column
          field="paymentMethod"
          headerText="Original Payment Method"
          textAlign="Left"
          width="160"
        />
        <e-column
          field="paymentType"
          headerText="Original Payment Type"
          textAlign="Left"
          width="140"
        />
        <e-column
          type="date"
          field="paymentDate"
          :format="gridDateFormat"
          headerText="Original Payment Date"
          textAlign="Left"
          width="140"
        />
        <e-column
          field="referencePO"
          headerText="Original Reference #"
          textAlign="Left"
          width="200"
          clipMode="EllipsisWithTooltip"
        />
        <e-column field="transactionNumber" headerText="Original Transaction #" width="200" />
        <e-column field="applicationRequestRequestId" headerText="" textAlign="Left" width="0" />
        <e-column field="invoiceStatus" headerText="Invoice Status" width="140" />
        <e-column
          field="requestUserEmail"
          headerText="Applicant Email"
          textAlign="Left"
          width="200"
          clipMode="EllipsisWithTooltip"
        />
        <e-column field="requestType" headerText="Application Type" textAlign="Left" width="240" clipMode="EllipsisWithTooltip"/>
        <e-column
          field="requestor"
          headerText="Applicant Name"
          textAlign="Left"
          width="160"
          clipMode="EllipsisWithTooltip"
        />
        <e-column
          field="company"
          headerText="Applicant Company"
          textAlign="Left"
          width="200"
          clipMode="EllipsisWithTooltip"
        />
        <e-column
          field="siteOwner"
          headerText="Site Owner"
          textAlign="Left"
          width="200"
          clipMode="EllipsisWithTooltip"
        />
        <e-column
          field="siteId"
          headerText="Site Number"
          textAlign="Left"
          width="200"
          clipMode="EllipsisWithTooltip"
        />
        <e-column
          field="siteAddress"
          headerText="Site Address"
          textAlign="Left"
          width="300"
          clipMode="EllipsisWithTooltip"
        />
        <e-column field="cancelledRefundMetBy"
        headerText="Update By User"
        textAlign="Left" width="200" />
        <e-column
          field="refundReason"
          headerText="Comments"
          textAlign="Left"
          width="200"
          clipMode="EllipsisWithTooltip"
          />
        <e-column headerText="Invoices" :commands="commands" textAlign="center" width="120" />
        <e-column
          headerText="Original Payment Receipts"
          :commands="commands2"
          textAlign="center"
          width="120"
        />
        <e-column
          headerText="Refund Receipt"
          :commands="commands4"
          textAlign="center"
          width="120"
        />
      </e-columns>
    </ejs-grid>
  </div>
</template>

<script>
import Vue from 'vue';
import {
  GridPlugin,
  Page,
  Toolbar,
  Edit,
  CommandColumn,
  Sort,
  Search,
  ExcelExport,
} from '@syncfusion/ej2-vue-grids';
import { tokenStorage } from '@/shared/storage-service';
import { mapGetters } from 'vuex';
import { reportExportFileName } from '@/utils/report-utils';
import { getInvoicePDF, getDocumentFile, getReceiptPDF } from '../services/accounting-api';
// import { getReceiptPDF } from '../services/receipt-api';
// eslint-disable-next-line import/extensions
import { getDataGridDateFormat, getExcelReportDate } from '../../../utils/date-utils.js';
import { SET_PREVIOUS_ACCOUNTING_TAB } from '../store';

Vue.use(GridPlugin);

export default {
  name: 'TransactionRefunds',
  props: {
    isValidUser: Boolean,
  },
  data() {
    return {
      commands: [
        {
          type: 'View Invoice',
          buttonOption: {
            cssClass: 'e-flat viewpdfbtn',
            iconCss: 'e-export-pdf e-icons',
          },
        },
      ],
      commands2: [
        {
          type: 'View Receipt',
          buttonOption: {
            cssClass: 'e-flat viewpdfbtn',
            iconCss: 'e-export-pdf e-icons',
          },
        },
      ],
      commands4: [
        {
          type: 'Refund Receipt',
          buttonOption: {
            cssClass: 'e-flat viewpdfbtn',
            iconCss: 'e-export-pdf e-icons',
          },
        },
      ],
      commands3: [
        {
          type: 'Edit',
          buttonOption: { cssClass: 'e-flat', iconCss: 'e-edit e-icons' },
        },
      ],
      sortOptions: { columns: [{ field: 'cancelledRefundMetDate', direction: 'Descending' }] },
      toolbarOptions: ['Search', 'ExcelExport'],
      pageSettings: { pageSize: 10 },
      target: '#target',
      wrapSettings: { wrapMode: 'Header' },
      gridDateFormat: getDataGridDateFormat(),
    };
  },
  computed: {
    ...mapGetters({
      accountingTransactionRefunds: 'accountingTransactionRefunds',
      loggedUser: 'loggedUser',
    }),
    loggedUserId() {
      return this.loggedUser?.id;
    },
  },
  methods: {
    created() {
      // Added clear button and its functionalities to Searchbar
      if (this.$refs.refAccountingTransactionRefundsGrid) {
        document
          .getElementById(`${this.$refs.refAccountingTransactionRefundsGrid.$el.id}_searchbar`)
          .addEventListener('keyup', (e) => {
            this.clearSearchEventListener(e, this.$refs.refAccountingTransactionRefundsGrid.$el.id);
          });
      }
    },
    clearSearchEventListener(e, gridId) {
      const searchBtnEle = document.getElementById(`${gridId}_searchbutton`);
      const clearBtnEle = searchBtnEle.cloneNode(true);
      clearBtnEle.id = `${gridId}_clearbutton`;
      clearBtnEle.classList.remove('e-search-icon');
      clearBtnEle.classList.add('e-clear-icon');

      clearBtnEle.addEventListener('click', () => {
        e.target.value = '';
        document.getElementById(`${gridId}_clearbutton`).remove();
      });

      if (e.target.value && searchBtnEle.parentNode.childElementCount === 2) {
        searchBtnEle.parentNode.insertBefore(clearBtnEle, searchBtnEle.parentNode.children[1]);
      } else if (!e.target.value || e.target.value === '') {
        document.getElementById(`${gridId}_clearbutton`).remove();
      }
    },
    rowRefundDataBound(args) {
      if (args.data.refundDocumentId === null) {
        // eslint-disable-next-line no-param-reassign
        args.row
          .querySelectorAll('.e-unboundcelldiv')[3]
          .querySelectorAll('button')[0].style.display = 'none';
      }
    },
    async cmdRefundInvoiceClick(args) {
      const invoice = args.rowData;
      const { invoiceId, orderNumber, refundDocumentId } = invoice;
      const accessToken = tokenStorage.getAccessToken();
      // eslint-disable-next-line default-case
      switch (args.commandColumn.type) {
        case 'View Invoice':
          await getInvoicePDF(accessToken, this.loggedUserId, invoiceId).then((res) => {
            window.location.href = `${res.config.baseURL}${res.config.url}`;
          });
          break;
        case 'View Receipt':
          if (orderNumber !== null && orderNumber !== undefined && orderNumber !== '') {
            await getReceiptPDF(accessToken, this.loggedUserId, orderNumber, invoiceId)
              .then((res) => {
                window.location.href = `${res.config.baseURL}${res.config.url}`;
              });
          }
          break;
        case 'Refund Receipt':
          if (
            refundDocumentId !== null
            && refundDocumentId !== undefined
            && refundDocumentId !== ''
          ) {
            await getDocumentFile(accessToken, this.loggedUserId, refundDocumentId).then((res) => {
              window.location.href = `${res.config.baseURL}${res.config.url}`;
            });
          }
          break;
        case 'Edit':
          this.$store.commit(SET_PREVIOUS_ACCOUNTING_TAB, { previousTab: 3 });
          this.$router.push(`/accounting/edittransactionrefund/${args.rowData.refundInvoiceId}`);
          break;
      }
    },

    onNewRefundClick() {
      this.$store.commit(SET_PREVIOUS_ACCOUNTING_TAB, { previousTab: 3 });
      this.$router.push('/accounting/newtransactionrefund');
    },

    excelQueryCellInfo(args) {
      // eslint-disable-next-line default-case
      switch (args.column.field) {
        case 'invoiceDate':
          // eslint-disable-next-line no-param-reassign
          args.value = getExcelReportDate(args.value);
          break;
        case 'paymentDate':
          // eslint-disable-next-line no-param-reassign
          args.value = getExcelReportDate(args.value);
          break;
        case 'cancelledRefundMetDate':
          // eslint-disable-next-line no-param-reassign
          args.value = getExcelReportDate(args.value);
          break;
      }
    },
    toolbarClick(args) {
      // eslint-disable-next-line default-case
      switch (args.item.text) {
        case 'Excel Export':
          this.$refs.refAccountingTransactionRefundsGrid.excelExport({
            fileName: reportExportFileName('Refunds.xlsx'),
          });
          break;
      }
    },
  },
  provide: {
    grid: [Page, Edit, Toolbar, CommandColumn, Sort, Search, ExcelExport],
  },
};
</script>
